export default __webpack_public_path__ + "static/media/hht2_ep05_timeline_q02_b.71133016.png";